import React, { useState } from 'react';
import Dropdown from '../../../common/dropdown/Dropdown';
import { TDirectorInfo } from '../../../types';
import { addIcon, greenCircle, selected } from '../../../assets/images/dashboard-business';
import Button2 from '../../global/Button2';
import { validateShareholder } from '../../../utils/ValidateShareholderInfo';

type TProps = {
  isAnyShareholderDirector: string;
  setIsAnyShareholderDirector: React.Dispatch<React.SetStateAction<string>>;
  setDirectorsInShareholders: React.Dispatch<React.SetStateAction<number[]>>;
  directorsInShareholders: number[];
  shareholders: TDirectorInfo[];
  setCurrent: React.Dispatch<React.SetStateAction<number>>;
  directors: TDirectorInfo[];
  setStep: React.Dispatch<React.SetStateAction<number>>;
  current: number;
};
const FirstPage = ({
  directorsInShareholders,
  isAnyShareholderDirector,
  setDirectorsInShareholders,
  setIsAnyShareholderDirector,
  shareholders,
  setCurrent,
  directors,
  setStep,
  current,
}: TProps) => {
  const completedSteps: boolean[] = JSON.parse(localStorage.getItem('completed-steps') ?? '[]');

  const updateCompletedSteps = () => {
    completedSteps[4] = true;
    localStorage.setItem('completed-steps', JSON.stringify(completedSteps));
  };

  const getDisabled = () => {
    if (directors) {
      for (let i = 0; i < directors.length; i++) {
        if (!validateShareholder(directors, i, 5)) {
          return true;
        }
      }
      return false;
    }
    return false;
  };
  return (
    <div>
      <div className='mb-5'>
        <Dropdown
          placeholder={isAnyShareholderDirector}
          className='border rounded-[2px] h-[52px] lg:w-[50%] w-[100%]'
          label='Will any of the shareholders be a director?'
          labelStyles='text-[#212121] text-sm font-poppins font-normal leading-[18px] pb-[5px] '
          options={[
            { value: 'Yes', label: 'Yes' },
            { value: 'No', label: 'No' },
          ]}
          setSelectedOption={(e: { label: string; value: string }) => {
            setIsAnyShareholderDirector(e.label);
          }}
          width='100%'
        />
        {isAnyShareholderDirector === 'No' && (
          <p className='text-xs text-[red] mt-1'>There must be at least one director</p>
        )}
        {isAnyShareholderDirector === 'Yes' && (
          <div className='w-50%'>
            <div className='my-4 font-[400]'>Select from this list of Shareholders</div>

            {shareholders?.map((shareholder, index) => (
              <div
                className='flex justify-between border-[1px] lg:w-[50%] cursor-pointer border-[#CDD8EA] p-3'
                key={shareholder?.email + shareholder?.identityNumber}
                style={{
                  backgroundColor: directorsInShareholders?.includes(index) ? '#f8b4005e' : '',
                }}
                onClick={() => {
                  if (directorsInShareholders?.includes(index)) {
                    const new_ = directorsInShareholders?.filter((dir) => dir !== index);
                    setDirectorsInShareholders(new_);
                  } else {
                    setDirectorsInShareholders([...directorsInShareholders, index]);
                  }
                  updateCompletedSteps();
                }}
              >
                <div className=''>{shareholder?.firstName + ' ' + shareholder?.lastName}</div>
                <img
                  src={directorsInShareholders?.includes(index) ? selected : greenCircle}
                  alt=''
                />
              </div>
            ))}
          </div>
        )}

        {isAnyShareholderDirector && (
          <div className='flex justify-between my-[35px] sl:mr-[4vw]'>
            {directors?.length > 0 && current < directors?.length && (
              <Button2
                type='submit'
                theme='tertiary'
                className='!px-3 !gap-1 md:px-3 py-[10px] text-[11px] inline-block '
                size='sm'
                icon={addIcon}
                underline={false}
                onClick={() => setCurrent((prev) => prev + 1)}
              >
                NEXT DIRECTOR
              </Button2>
            )}

            {(!directors?.length || (directors?.length > 0 && current === directors?.length)) && (
              <Button2
                type='submit'
                theme='tertiary'
                className='!px-3 !gap-1 md:px-3 py-[10px] text-[11px] inline-block '
                size='sm'
                icon={addIcon}
                underline={false}
                onClick={() => setCurrent((prev) => prev + 1)}
              >
                ADD NEW DIRECTOR
              </Button2>
            )}

            {directorsInShareholders?.length > 0 && (
              <Button2
                type='submit'
                theme='primary'
                className='!px-3 !gap-1 md:px-3 py-[10px] text-[11px] inline-block '
                size='sm'
                underline={false}
                onClick={() => {
                  setStep((prev) => prev + 1);
                  updateCompletedSteps();
                }}
                disabled={getDisabled()}
              >
                PREVIEW APPLICATION
              </Button2>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default FirstPage;
